// src/components/myteconstruction/auth/WelcomeScreen.js

import React from 'react';
import ThreeSphere from 'shared/components/ThreeSphere';

function WelcomeScreen() {
  return (
    <div className="relative min-h-screen">
      {/* Sphere in background */}
      <div className="absolute inset-0 z-0">
        <ThreeSphere noAutoTransition zoomMultiplier={3.5} />
      </div>

      <div className="relative z-10 flex items-center justify-center min-h-screen px-4">
        <div className="max-w-2xl w-full bg-gray-900 bg-opacity-90 p-8 rounded-lg shadow-lg text-white">
          <div className="text-center mb-6">
            <img
              src="/LogoFile.png"
              alt="Myte Construction Logo"
              className="mx-auto w-24 mb-4"
            />
            <h1 className="text-3xl font-bold mb-3">Welcome to Myte Construction!</h1>
            <p className="text-blue-200">
              Your email has been verified. You can now explore your Organization's dashboard and start leveraging AI to streamline your construction workflows.
            </p>
          </div>

          {/* The extended details about the system */}
          <div className="space-y-6 text-blue-100 leading-relaxed">
            <p>
              <strong>Workers & Teams:</strong> Add or import all your workers (name, email, phone, etc.) into your organization. Mark them as “On the Bench” or assign them to active projects.
            </p>
            <p>
              <strong>Cost Codes & Descriptions:</strong> Create or upload your own custom list of cost codes and tasks, so timesheets accurately reflect your company’s billing codes.
            </p>
            <p>
              <strong>Invite Foremen & Project Managers:</strong> Expand your team and give them the right permissions. Foremen can speak timesheets into existence, and PMs can verify, approve, or reject them with reasons.
            </p>
            <p>
              <strong>Project Management:</strong> Create projects with contract numbers, descriptions, client contacts, and more. Add cost codes specifically for that project, track workers assigned to the job, and keep an eye on daily logs.
            </p>
            <p>
              <strong>Speech-to-Payroll:</strong> Foremen use Myte’s voice-driven timesheet feature. PMs can finalize hours, generate PDF timesheets, and produce payroll or manhour summary reports anytime.
            </p>
            <p>
              <strong>Data & Reporting:</strong> Generate aggregated timesheets, per-project or per-worker labor reports. Save countless hours on data entry with immediate clarity on standard time, OT, and double-time hours.
            </p>
          </div>

          <div className="mt-8 text-center">
            <a
              href="/myteconstruction/login"
              className="inline-block px-6 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md transition"
            >
              Proceed to Login
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WelcomeScreen;
